<template>
  <div id="wangeditor">
    <div
      ref="editorElem"
      style="text-align: left"
      :style="{ width: width + 'px' }"
    ></div>
  </div>
</template>
<script>
import * as utils from "@/utils/utils";
import { upload_image, upload_file } from "@/service/tools";
import E from "wangeditor";
export default {
  name: "Editor",
  props: {
    content: {
      type: String,
    },
    width: {
      type: String,
      default: "950",
    },
  },
  data() {
    return {
      editor: null,
      editorContent: "",
      indexWidth: "",
      wEditor: "",
      uploadImgFile: [],
      uploadImgUrl: [],
    };
  },
  // catchData是一个类似回调函数，来自父组件，当然也可以自己写一个函数，主要是用来获取富文本编辑器中的html内容用来传递给服务端
  created() {
    this.indexWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
  },
  methods: {
    catchData(html) {
      this.$emit("get_editor", html);
    },
  },
  watch: {
    content: function (newVal, oldVal) {
      // this.editor.txt.html(newVal);
      if (newVal !== this.editor.txt.html()) {
        this.editor.txt.html(newVal); //根据父组件传来的值设置html值
      }
    },
  },
  mounted() {
    this.editor = new E(this.$refs.editorElem);
    // 编辑器的事件，每次改变会获取其html内容

    this.editor.config.onchange = (html) => {
      this.editorContent = html;
      this.catchData(this.editorContent); // 把这个html通过catchData的方法传入父组件
    };
    // 上传图片到服务器，base64形式
    this.editor.config.uploadImgShowBase64 = false; // base 64 存储图片，如果这个参数设置为true的话，就不用配置服务器端上传地址
    this.editor.config.uploadFileName = "image";
    this.editor.config.uploadImgMaxSize = 20 * 1024 * 1024;
    //上传文件个数
    this.editor.config.uploadImgMaxLength = 10;
    this.editor.config.uploadImgHeaders = {
      "web-authorization": localStorage.getItem("token"), // 设置请求头
      requestSrc: "WEB", // 设置请求头
    };
    // machine: utils.getPCtoken(), // 设置请求头
    this.editor.config.debug = true;
    this.editor.config.uploadImgServer = "/api/bbm_tools/aliyun/putImages";

    this.editor.config.uploadImgHooks = {
      fail: function (xhr, editor, result) {
        this.$message.error("上传图片失败");
      },
      error: function (xhr, editor) {
        this.$message.error("上传图片出错");
      },
      timeout: function (xhr, editor) {
        this.$message.error("上传图片超时");
      },
      //自定义上传图片，回显图片
      customInsert: function (insertImg, result, editor) {
        var url = result.data;
        // url 是后台返回的上传图片的路径
        insertImg(url);
      },
    };
    this.editor.config.customUploadImg = (files, insert) => {
      let uploadImgUrl = [],
        uploadFileList = files;
      files.forEach((item) => {
        uploadImgUrl.push("");
      });
      for (let i = 0; i < files.length; i++) {
        utils.compress(files[i], function (val) {
          var formData = new FormData();
          formData.append("image", val); //  多张图片文件都放进一个form-data，有些小伙伴说这里应该这样写：formData.append("file[" + i + "]", files[i], files[i].name)，后端才能拿到完整的图片数组，其实不然，用这个formData.getAll("file")方法恰好拿到数组，或者也可以forEach获取，有很多种办法。
          upload_image(formData).then((res) => {
            if (res.flag) {
              uploadImgUrl.splice(i, 1, res.data);
              uploadFileList.splice(0, 1);
              if (uploadFileList.length == 0) {
                uploadImgUrl.forEach((item) => insert(item));
              }
            }
          });
        });
      }
    };
    this.editor.config.menus = [
      // 菜单配置
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "strikeThrough", // 删除线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      // "link", // 插入链接
      "list", // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "emoticon", // 表情
      "image", // 插入图片
      "table", // 表格
      "code", // 插入代码
      "undo", // 撤销
      "redo", // 重复
    ];
    this.editor.create(); // 创建富文本实例
  },
};
</script>
<style >
.w-e-full-screen-editor {
  width: 100% !important;
  padding-left: 200px;
  box-sizing: border-box;
  height: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/tools/wangeditor.vue